// Sales document + purchase document config shared across pages
export const SDOC = {
  quotation: {
    label: "Quotation", plural: "Quotations", api: "quotation", prefix: "QTN",
    base: "/sales/quotations", dateLabel: "Valid Until",
    convert: [["sales_order", "Convert to Sales Order"], ["invoice", "Convert to Invoice"]],
  },
  sales_order: {
    label: "Sales Order", plural: "Sales Orders", api: "sales_order", prefix: "SO",
    base: "/sales/orders", dateLabel: "Expected Delivery",
    convert: [["delivery_challan", "Convert to Delivery Challan"], ["invoice", "Convert to Invoice"]],
  },
  delivery_challan: {
    label: "Delivery Challan", plural: "Delivery Challans", api: "delivery_challan", prefix: "DC",
    base: "/sales/delivery-challans", dateLabel: "",
    convert: [["invoice", "Convert to Invoice"]],
  },
};

export const TARGET_ROUTE = {
  quotation: "/sales/quotations", sales_order: "/sales/orders",
  delivery_challan: "/sales/delivery-challans", invoice: "/sales/invoices",
};

export const PCONF = {
  purchase_invoice: { label: "Purchase Invoice", plural: "Purchase Invoices", api: "purchase_invoice", base: "/purchases/invoices", showBill: true, showPaid: true },
  purchase_order: { label: "Purchase Order", plural: "Purchase Orders", api: "purchase_order", base: "/purchases/orders", showBill: false, showPaid: false },
  purchase_return: { label: "Purchase Return", plural: "Purchase Returns", api: "purchase_return", base: "/purchases/returns", showBill: true, showPaid: false },
};

export function downloadCSV(filename, headers, rows) {
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const lines = [headers.map(esc).join(",")];
  rows.forEach((r) => lines.push(r.map(esc).join(",")));
  const blob = new Blob([lines.join("\n")], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}
